import styled from '@emotion/styled'
import { Button } from 'components/patterns'
import InputLabel from 'components/patterns/Inputs/InputLabel'

export const HeaderStyled = styled.div`
  margin-bottom: 18px;
`

export const LowerNavButton = styled(Button)`
  margin: 6px 0;
  display: block;
`

export const StyledLabel = styled(InputLabel)`
  display: block;
`

export const StyledHarnessBtnWrapper = styled.div`
  margin-bottom: 6px;
  display: flex;
  justify-content: flex-end;
`
